
export default function Founder() {
  return (
    <section className="py-16 md:py-32 px-6 md:px-20 bg-white">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-16 items-center">
          {/* Image */}
          <div className="order-2 lg:order-1">
            <div className="relative w-full" style={{ height: '500px' }}>
              <img 
                src="https://static.readdy.ai/image/1b8131d487c4d2fd3e7c4221ca00b7be/f89212d5e2549d1039a68e9db1ba251c.jpeg"
                alt="Fundadora MB Óticas"
                className="w-full h-full object-cover object-top rounded-2xl"
              />
            </div>
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2">
            <div className="mb-6 md:mb-8">
              <span className="text-gray-500 text-xs font-medium">/Fundadora</span>
            </div>

            <h2 className="text-3xl md:text-5xl font-light text-gray-900 mb-6 md:mb-8" style={{ fontFamily: 'Playfair Display, serif' }}>
              Visão que Transforma
            </h2>

            <div className="space-y-4 md:space-y-6 text-gray-700 text-base md:text-lg leading-relaxed">
              <p>
                Com mais de três décadas de dedicação ao cuidado visual, nossa fundadora construiu muito mais que uma ótica — criou um legado de excelência e humanização no atendimento.
              </p>
              
              <p>
                Sua paixão por transformar a forma como as pessoas enxergam o mundo vai além dos óculos. É sobre proporcionar confiança, estilo e bem-estar a cada cliente que passa por nossas portas.
              </p>

              <p className="font-medium text-gray-900">
                "Acredito que cada pessoa merece enxergar o mundo com clareza e beleza. Nossa missão é tornar isso possível com produtos de qualidade e atendimento que realmente se importa."
              </p>
            </div>

            <div className="mt-8 md:mt-10 flex items-center gap-4">
              <div className="w-16 h-0.5 bg-teal-500"></div>
              <div>
                <p className="text-lg md:text-xl font-semibold text-gray-900">Pamela Alves</p>
                <p className="text-sm text-gray-600">Fundadora & CEO, MB Óticas</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
